module.exports = __webpack_public_path__ + "img/error.48ae8ae0.svg";